import React, { useState, useEffect, useRef } from "react";
import {
  Container,
  TextField,
  IconButton,
  Typography,
  Box,
  Paper,
  CircularProgress,
} from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import axios from "axios";

const NewBarterGPTUI = () => {
  const [query, setQuery] = useState("");
  const [chatHistory, setChatHistory] = useState([]);
  const [loading, setLoading] = useState(false);
  const chatContainerRef = useRef(null);

  useEffect(() => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop =
        chatContainerRef.current.scrollHeight;
    }
  }, [chatHistory]);

  const handleQuery = async () => {
    if (!query) return;

    setLoading(true);
    try {
      const response = await axios.post("home/external_gpt", {
        question: query,
      });
      setChatHistory((prevHistory) => [
        ...prevHistory,
        { question: query, answer: response.data.answer },
      ]);
      setQuery("");
    } catch (error) {
      console.error("Error fetching response", error);
      alert("Error fetching response");
    }
    setLoading(false);
  };

  const renderTextWithLinks = (text) => {
    // Regex to match URLs starting with http or https
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    // Split the text using the regex
    const parts = text.split(urlRegex);

    return parts.map((part, index) => {
      // If the part matches the URL pattern, wrap it in an anchor tag
      if (urlRegex.test(part)) {
        return (
          <a key={index} href={part} target="_blank" rel="noopener noreferrer">
            {part}
          </a>
        );
      }
      // Otherwise, just return the text
      return <span key={index}>{part}</span>;
    });
  };

  return (
    <Container
      maxWidth="sm"
      sx={{
        mt: 1,
        display: "flex",
        flexDirection: "column",
        height: "100%",
        maxHeight: "clamp(300px, 60vh, 500px)",
      }}
    >
      <Box
        ref={chatContainerRef}
        sx={{
          flexGrow: 1,
          overflowY: "auto",
          mb: 2,
          p: 2,
          borderRadius: 2,
          bgcolor: "#fff",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {chatHistory.map((chat, index) => (
          <React.Fragment key={index}>
            <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 1 }}>
              <Paper
                sx={{
                  p: 1.5,
                  maxWidth: "75%",
                  borderRadius: "10px",
                  bgcolor: "#edf2f4",
                }}
              >
                <Typography sx={fontStyle}>{chat.question}</Typography>
              </Paper>
            </Box>
            <Box sx={{ display: "flex", justifyContent: "flex-start", mb: 1 }}>
              <Paper
                sx={{
                  p: 1.5,
                  maxWidth: "75%",
                  borderRadius: "10px",
                  bgcolor: "#f9f7f3",
                }}
              >
                <Typography sx={fontStyle}>
                  {renderTextWithLinks(chat.answer)}
                </Typography>
              </Paper>
            </Box>
          </React.Fragment>
        ))}
      </Box>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <TextField
          fullWidth
          label="Got barter questions? Ask me!"
          variant="outlined"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          onKeyPress={(e) => e.key === "Enter" && handleQuery()}
          sx={{
            padding: "0px",
            height: "50px",
            background: "#FFFFFF",
            borderRadius: "10px",
            marginLeft: 1,
            minWidth: "200px",
            maxWidth: "100%",
            boxShadow:
              "0px 4px 10px rgba(0, 0, 0, 0.2), 0px 2px 5px rgba(0, 0, 0, 0.15)",

            "& .MuiOutlinedInput-root": {
              "& fieldset": {
                border: "none", // Removes the border
              },
              "&:hover fieldset": {
                border: "none", // Prevents border on hover
              },
              "&.Mui-focused fieldset": {
                border: "none", // Prevents border when focused
              },
            },
          }}
          InputProps={{
            sx: {
              fontSize: "13px", // Increase font size
              fontWeight: 400,
              fontFamily: "Poppins",
            },
          }}
          InputLabelProps={{
            sx: {
              fontSize: "12px", // Increase font size
              fontWeight: 500,
              fontFamily: "Poppins",
            },
          }}
        />
        <IconButton
          color="primary"
          onClick={handleQuery}
          disabled={loading}
          fontSize={"24px"}
          sx={{
            padding: "10px",
            background: "transparent",
            borderRadius: "10px",
            fontSize: "24px",
          }}
        >
          {loading ? (
            <CircularProgress size={24} />
          ) : (
            <SendIcon size={24} fontSize="24px" />
          )}
        </IconButton>
      </Box>
    </Container>
  );
};

export default NewBarterGPTUI;

const fontStyle = {
  fontFamily: "Poppins",
  fontStyle: "normal",
  fontWeight: 400,
  fontSize: "13px",
  lineHeight: "21px",
};
